import React from "react";
import { KBarPortal, KBarPositioner, KBarAnimator, KBarSearch } from "kbar";
import SearchResults from "./SearchResults";

const animatorStyles = {
    maxWidth: "600px",
    width: "100%",
    background: "#fff",
    color: "#333",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow:
        "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
};
const searchStyle = {
    padding: "12px 16px",
    fontSize: "16px",
    width: "100%",
    boxSizing: "border-box",
    outline: "none",
    border: "none",
    background: "var(--background)",
    color: "var(--foreground)",
    borderBottom: "1px solid #eee",
    marginBottom: "8px",
};

export default function CommandMenu(props) {
    return (
        <KBarPortal>
            <KBarPositioner style={{ zIndex: 99 }}>
                <KBarAnimator style={animatorStyles}>
                    <KBarSearch style={searchStyle} />
                    <SearchResults />
                </KBarAnimator>
            </KBarPositioner>
        </KBarPortal>
    );
}
